import * as actionTypes from "./actionTypes";
import instance from "./instance";

export const FetchUsher = (usherID, dataType) => async (dispatch) => {
  try {
    const response = await instance.get(
      `ushers/${usherID}/?dataType=${dataType}`
    );
    dispatch({
      type: actionTypes.SET_USHER_OBJ,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    error.response ? console.error(error.response.data) : console.error(error);
  }
};

export const EditUsherProfile = (usherID, data) => async () => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    await instance.put(`ushers/${usherID}/`, formData);
    return true;
  } catch (error) {
    error.response ? console.error(error.response.data) : console.error(error);
    return false;
  }
};

export const EditUsherStatus = (usherID, data) => async () => {
  try {
    await instance.put(`ushers/${usherID}/status-update/`, data);
  } catch (error) {
    error.response ? console.error(error.response.data) : console.error(error);
  }
};

export const FetchUsherHistory = (usherID) => async () => {
  try {
    const response = await instance.get(`ushers/${usherID}/history/`);
    return response.data;
  } catch (error) {
    error.response ? console.error(error.response.data) : console.error(error);
  }
};

export const FetchInitiativeUsherDetails =
  (usherID, initiativeID) => async () => {
    try {
      const response = await instance.get(
        `initiatives/${initiativeID}/ushers/${usherID}/`
      );
      return response.data;
    } catch (error) {
      error.response
        ? console.error(error.response.data)
        : console.error(error);
    }
  };

export const InitiativeUsherApply = (usherID, initiativeID) => async () => {
  try {
    const response = await instance.post(
      `/initiatives/${initiativeID}/apply/`,
      {
        usher: usherID,
        initiative: initiativeID,
        status: "Pending",
      }
    );
    return response.data;
  } catch (error) {
    error.response ? console.error(error.response.data) : console.error(error);
  }
};

export const EditInitiativeUsher =
  (usherID, initiativeID, data) => async () => {
    try {
      await instance.put(
        `initiatives/${initiativeID}/ushers/${usherID}/`,
        data
      );
    } catch (error) {
      error.response
        ? console.error(error.response.data)
        : console.error(error);
    }
  };

export const FetchTagsList = () => async () => {
  try {
    const response = await instance.get(`/tags/`);
    return response.data;
  } catch (error) {
    error.response ? console.error(error.response.data) : console.error(error);
  }
};

export const FetchAttendanceHistoryRecordsList =
  (initiativeUsherID) => async () => {
    try {
      const response = await instance.get(
        `/attendance-history/${initiativeUsherID}/list/`
      );
      return response.data;
    } catch (error) {
      error.response
        ? console.error(error.response.data)
        : console.error(error);
    }
  };
